import React, { useState } from "react";
import cn from "classnames";
import styles from "./Page.module.sass";
import Sidebar from "../Sidebar";
import Header from "../Header";
import useDarkMode from "use-dark-mode";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
const Page = ({ wide, children, title, showBreadcrumbs = false  }) => {
  const [visible, setVisible] = useState(false);
  const darkMode = useDarkMode(false);
  return (
    <>
      <div
        className={cn(styles.page, {
          "bg-[#272b30]": darkMode.value,
          "bg-[#f4f4f4]": !darkMode.value,
        })}
      >
        <Sidebar
          className={cn(styles.sidebar, {
            [styles.visible]: visible,
          })}
          onClose={() => setVisible(false)}
        />
        <Header onOpen={() => setVisible(true)} />
        <div className={styles.inner}>
          <div
            className={cn(styles.container, {
              [styles.wide]: wide,
            })}
          >
            {showBreadcrumbs ? (
              <>
                <Breadcrumb />
              </>
            ) : (
              title && <div className={cn(styles.title)}>{title}</div>
            )}
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
